//
//
//
//
//
//

import { faAward } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'Ribbon',
  props: {
    variant: {
      type: String,
      default: 'top-left'
    }
  },
  computed: {
    icon () {
      return faAward
    },
    classes () {
      return ['ribbon', `text-${this.variant}`]
    }
  }
}
